export const fetchForEachAreas = (masterBookObjList) => {
  if (masterBookObjList.length == 0) return [];

  // areaごとにまとめる
  const masterBooksForEachAreas = {};

  masterBookObjList.forEach((masterBook) => {
    if (masterBooksForEachAreas[masterBook.area]) {
      masterBooksForEachAreas[masterBook.area].push(masterBook);
    } else {
      masterBooksForEachAreas[masterBook.area] = [masterBook];
    }
  });

  console.log("forEachAreas return>>", masterBooksForEachAreas);
  return masterBooksForEachAreas;
};
